import React, { useState } from 'react';
import AdminLeftMenu from "../../../templates/layouts/private/admin/left-menu";
import Logo from "../../../assets/images/logo.png";
import LogoIcon from "../../../assets/icons/meetocto_icon.svg";

const LeftMenu = () => {

    const [sideBar, setSideBar] = useState(false);
    const sidebarCollapse = () => setSideBar((prevState) => !prevState);

    return (
        <div className={`integ-sidebar d-lg-block d-none ${sideBar ? "active" : ''}`}>
            <div className="head">
                <div className="head-logo">
                    <img src={sideBar ? LogoIcon : Logo} alt="Logo" />
                    <button
                        type="button"
                        className="side-colappse"
                        onClick={sidebarCollapse}
                    >
                        <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                        >
                        <path
                            d="M7.70726 4.70711C8.09778 4.31658 8.09778 3.68342 7.70726 3.29289C7.31673 2.90237 6.68357 2.90237 6.29304 3.29289L1.58594 8L6.29304 12.7071C6.68357 13.0976 7.31673 13.0976 7.70726 12.7071C8.09778 12.3166 8.09778 11.6834 7.70726 11.2929L4.41436 8L7.70726 4.70711Z"
                            fill="currentColor"
                        ></path>
                        <path
                            d="M13.7073 4.70711C14.0978 4.31658 14.0978 3.68342 13.7073 3.29289C13.3167 2.90237 12.6836 2.90237 12.293 3.29289L7.58594 8L12.293 12.7071C12.6836 13.0976 13.3167 13.0976 13.7073 12.7071C14.0978 12.3166 14.0978 11.6834 13.7073 11.2929L10.4144 8L13.7073 4.70711Z"
                            fill="currentColor"
                        ></path>
                        </svg>
                    </button>
                </div>
            </div>
            <div className="body scrole cust-main-sidebar">
                <AdminLeftMenu></AdminLeftMenu>
            </div>
        </div>
    );

}

export default LeftMenu;